function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var CabinClass = function CabinClass(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60533 2.55274C7.40457 2.33477 8.22918 2.80598 8.44716 3.60521L11.0452 13.1314C11.1045 13.349 11.3021 13.4999 11.5276 13.4999H17C17.8284 13.4999 18.5 14.1715 18.5 14.9999C18.5 15.8283 17.8284 16.4999 17 16.4999H10.191C9.40179 16.4999 8.71027 15.9717 8.50262 15.2103L5.55286 4.39456C5.33489 3.59533 5.8061 2.77072 6.60533 2.55274Z",
    stroke: color || '#333333',
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5L16.8241 19.2471C17.161 20.37 16.3202 21.5 15.1479 21.5H7.5",
    stroke: color || '#333333',
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.5H17.5",
    stroke: color || '#333333',
    strokeLinecap: "round"
  }));
};